// A clip with no colour of its own (2026-10-09).
//
// Audio that never lived in Live — a folder of stems uploaded in a browser, an
// Audiotool capture — has no clip colour. Such a clip is stored as this grey,
// and it MEANS "none": the browser draws it in its lane's colour
// (web-shared arrangement.ts clipColor), and Live must leave a clip it builds
// from one alone, so the clip takes the track's colour the way any new clip
// in Live does. Writing the grey in turned every imported clip grey.

export const NO_CLIP_COLOUR = 0x808080;

/** Whether a wire colour is "none": absent, or the no-colour grey. */
export function isNoClipColour(color: number | null | undefined): boolean {
  return color === null || color === undefined || (color & 0xffffff) === NO_CLIP_COLOUR;
}
